import DbService from 'resources/db.service';

import { DEAL_STATUSES } from 'resources/deal/deal.constants';

import schema from './deal.schema';

const service = new DbService('deals', { schema });

const createDeal = async ({
  type,
  realtorId,
  coordinatorId,
  company,
  isSample,
}) => {
  const dealResult = await service.create({
    realtor_id: realtorId,
    coordinator_id: coordinatorId,
    client_ids: [],
    company_id: company.id,
    due_date_calculation: company.due_date_calculation,
    type,
    status: DEAL_STATUSES.PRE_LISTING,
    is_sample: !!isSample,
  });

  return dealResult.data[0];
};

const updateDeal = async (data) => {
  const response = await service.updateOne(
    {
      id: data.id,
    },
    data,
  );

  if (response.isBadRequest) {
    return null;
  }

  return response.data[0];
};

const getDealsByClientId = async (clientId, filters = {}) => {
  // const request = service
  //   .select()
  //   .contains('client_ids', [clientId]);

  // if (filters.onlyActive) {
  //   request.not('status', 'in', '("voided","closed")');
  // }

  // if (filters.onlyInactive) {
  //   request.in('status', ['voided', 'closed']);
  // }

  // let response = await request;

  let deals = await service.selectByKey({
    selectKey: 'getDealsByClientId',
    params: { clientId, filters },
  });

  deals = service.processResponse(deals);

  return deals;
};

const getDealsByClientIds = async (clientIds, companyId, filters = {}) => {
  if (!clientIds.length || !companyId) {
    return [];
  }

  // let response = await service
  //   .select()
  //   .match({ company_id: companyId })
  //   .overlaps('client_ids', clientIds);

  // const deals = response.data || [];

  // if (filters.onlyActive) {
  //   deals = deals.filter((deal) => deal.status !== 'voided' && deal.status !== 'closed');
  // }

  // if (filters.onlyInactive) {
  //   deals = deals.filter((deal) => deal.status === 'voided' || deal.status === 'closed');
  // }

  let deals = await service.selectByKey({
    selectKey: 'getDealsByClientIds',
    params: { clientIds, filters },
  });

  deals = service.processResponse(deals);

  return deals;
};

const getDealsByRealtorId = async (realtorId, filters = {}) => {
  if (!realtorId) {
    return null;
  }

  // const request = service
  //   .select()
  //   .match({ realtor_id: realtorId });

  // if (filters?.onlyActive) {
  //   request.not('status', 'in', '("voided","closed")');
  // }

  // if (filters?.onlyInactive) {
  //   request.in('status', ['voided', 'closed']);
  // }

  // let response = await request;

  let response = await service.selectByKey({
    selectKey: 'getDealsByRealtorId',
    params: { realtorId, filters },
  });

  response = service.processResponse(response);

  return response.data.length > 0 ? response.data : null;
};

const getSampleDealByRealtorId = async (realtorId) => {
  // let response = await service
  //   .select()
  //   .match({
  //     realtor_id: realtorId,
  //     is_sample: true,
  //   });

  let response = await service.selectByKey({
    selectKey: 'getSampleDealByRealtorId',
    params: { realtorId },
  });

  response = service.processResponse(response);

  return response.data.length > 0 ? response.data[0] : null;
};

const getDealsByCompanyId = async (companyId, filters = {}) => {
  if (!companyId) {
    return null;
  }

  // const request = service.select().match({ company_id: companyId });

  // if (filters?.onlyActive) {
  //   request.not('status', 'in', '("voided","closed")');
  // }

  // if (filters?.onlyInactive) {
  //   request.in('status', ['voided', 'closed']);
  // }

  // let response = await request;

  let response = await service.selectByKey({
    selectKey: 'getDealsByCompanyId',
    params: { filters },
  });

  response = service.processResponse(response);

  return response.data.length > 0 ? response.data : null;
};

const getTransactionDocumentIds = async (dealId) => {
  // let response = await service
  //   .select()
  //   .match({ id: dealId })
  //   .not('transaction', 'is', null);

  let response = await service.publicSelectByKey({
    selectKey: 'getTransactionDocumentIds',
    params: { dealId },
  });

  response = service.processResponse(response);

  return response.data.length > 0 ? response.data[0].transaction.document_ids : null;
};

const getDealByDocumentId = async (documentId) => {
  // let response = await service
  //   .select()
  //   .contains('transaction->document_ids', JSON.stringify([documentId]));

  let response = await service.selectByKey({
    selectKey: 'getDealByDocumentId',
    params: { documentId },
  });

  response = service.processResponse(response);

  return response.data.length > 0 ? response.data[0] : null;
};

export default Object.assign(service, {
  createDeal,
  updateDeal,
  getDealsByClientId,
  getDealsByRealtorId,
  getSampleDealByRealtorId,
  getDealsByCompanyId,
  getTransactionDocumentIds,
  getDealByDocumentId,
  getDealsByClientIds,
});
